/* global HTMLDivElement, KeyboardEvent */
/**
 * WaitingModal — collect waitingFor + waitingUntil before parking an inbox item.
 * Extracted from inbox-view.tsx (behavior-preserving refactor).
 */
import { useEffect, useRef, useState } from "react";
import { useFocusTrap } from "../lib/focus-trap";
import { BentoDateInput } from "./bento-ui";

interface WaitingModalProps {
  onConfirm: (waitingFor: string, waitingUntil: string) => void;
  onClose: () => void;
}

export function WaitingModal({ onConfirm, onClose }: WaitingModalProps) {
  const [who, setWho] = useState("");
  const [until, setUntil] = useState("");
  const panelRef = useRef<HTMLDivElement>(null);
  useFocusTrap(panelRef, true);

  // Escape closes the modal
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => { if (e.key === "Escape") onClose(); };
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [onClose]);

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4" onClick={onClose} role="dialog" aria-modal="true" aria-labelledby="waiting-modal-title">
      <div ref={panelRef} data-testid="waiting-modal" className="w-full max-w-sm rounded-3xl bg-white p-5 shadow-2xl" onClick={(e) => e.stopPropagation()}>
        <h2 id="waiting-modal-title" className="mb-4 font-display text-[16px] font-bold">Đang chờ ai / điều gì?</h2>
        <div className="flex flex-col gap-3">
          <div className="flex flex-col gap-1">
            <label className="text-[12px] font-semibold text-ink-600">Đang chờ (tuỳ chọn)</label>
            <input
              value={who}
              onChange={(e) => setWho(e.target.value)}
              placeholder="VD: Anh Nam, email xác nhận…"
              className="rounded-xl border border-ink-200 bg-ink-50 px-3 py-2 text-[13px] outline-none focus:border-brand-400 focus:bg-white"
            />
          </div>
          <div className="flex flex-col gap-1">
            <label className="text-[12px] font-semibold text-ink-600">Nhắc lại vào ngày (tuỳ chọn)</label>
            <BentoDateInput
              value={until}
              onChange={(e) => setUntil(e.target.value)}
              className="rounded-xl border border-ink-200 bg-ink-50 px-3 py-2 text-[13px] outline-none focus:border-brand-400 focus:bg-white"
            />
          </div>
        </div>
        <div className="mt-4 flex gap-2">
          <button onClick={onClose} className="flex-1 rounded-2xl bg-ink-100 py-2.5 text-[13px] font-bold text-ink-600 hover:bg-ink-200">Huỷ</button>
          <button
            data-testid="waiting-confirm"
            onClick={() => onConfirm(who, until)}
            className="flex-1 gbrand rounded-2xl py-2.5 text-[13px] font-bold text-white"
          >
            Lưu
          </button>
        </div>
      </div>
    </div>
  );
}
